exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect[data-v-262a5401] {\n    z-index: 99999;\n}\n", ""]);

// exports
